import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import CustomizedCard from '../../CSSComponent/card'
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import red from '@material-ui/core/colors/red';
import EmailIcon from '@material-ui/icons/Email';
import ShareIcon from '@material-ui/icons/Share';
import ChevronRight from '@material-ui/icons/ChevronRight';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { Divider } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import TransactionTable from "../../Transactions/TransactionTableMin";
import ChipInput from 'material-ui-chip-input'
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import Paper from '@material-ui/core/Paper';
//dialog related import
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DiscriptionTable from '../../Entities/DescriptionTable/DiscriptionTable';
import HorizontalTable from '../DescriptionTable/HorizontalTable';
import AlertChip from "../../AlertChip";
import Badge from '@material-ui/core/Badge';

import CardActionArea from '@material-ui/core/CardActionArea';
import VendorDetail from './VendorDetail'
import VendorAnalysis from './VendorAnalysis'

import Grid from '@material-ui/core/Grid';
import config from "../../../config/config";
import axios from 'axios';
import { grid_spacing, styles } from '../../CSS/Styles'
import scale from '../../../pic/scale.PNG';
import grey from '../../../pic/grey.PNG';
import dot from '../../../pic/dot.PNG';
import VenderRiskScore from "./VenderRiskScore";

import CustomizedTab from '../../CSSComponent/tabs'
import CustomizedNameCard from '../../CSSComponent/nameCard'

class RecipeReviewCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
            actionView: false,
            chips: [],
            open: false,
            value: 0,
            headers: ["Address", "Tel", "Email", "CreatedBy", "Flags"],
            descriptionData: {
                Address: "1232",
                Tel: "342342",
                Email: "dfasddfs",
                CreatedBy: "fdsdfadf",
                Flags: [{
                    name: "Same Director",
                    color: "high"
                },{
                name: "Duplicate Address",
                color: "mid" 
                }]    
            },
            data: [],
            height:0,
            width: 0,
        };
        this.getVendorDetail = this.getVendorDetail.bind(this);
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }


    componentWillMount() {
        this._isMounted = false;
    }
    componentDidMount() {
        this._isMounted = true;
        this.getVendorDetail();
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        //console.log("vendor data load finish");
    }
    componentWillUnmount(){
        window.removeEventListener('resize', this.updateWindowDimensions);
    }
    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }
    componentDidUpdate(prevProps) {
        if (prevProps.detailID !== this.props.detailID)
        {
            this.getVendorDetail(this.props.detailID);
            //console.log("vendor data update finish");
        }
    }
        
    getVendorDetail = (id) => {
        //console.log("test axios getVendors");
        if (id)
        {
            axios.get(config.entity(id))
                .then(res => {
                    let vendors = res.data;
                    this.setState({ data: vendors});
                    // console.log(this.state.data);
                })
        }
    }

    handleExpandClick = () => {
        this.setState(state => ({ expanded: !state.expanded }));
    };
    handleViewToggle = () => {
        this.setState(state => ({ actionView: this.state.actionView ? false : true }));
    }
    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };
    //for tabs
    handleChange = (event, value) => {
        //console.log(value);
        this.setState({ value });
    };

    render(){
        const {data} = this.state;
        //console.log("render");
        //console.log(data);
        return data.name ? this.renderDetail() : (
            <span>Loading data...</span>
        )
    }

    renderDetail() {
        const { classes } = this.props;
        const { data } = this.state;
        console.log(data)
        const vender_risk_score = (<VenderRiskScore/>);
        const tabdata = [
            {
                id:0,
                label:'Details',
                content: (<VendorDetail data = {data}/>)
            },
            {
                id:1,
                label:'Analysis',
                content: (<VendorAnalysis data = {data}/>)
            },
            {
                id:2,
                label:'High Risk',
                badge: 1,
                content: (<Typography variant="body1" align="center" > 2  </Typography>)
            },
            {
                id:3,
                label:'Medium Risk',
                badge: 1,
                content: (<Typography variant="body1" align="center" > 3  </Typography>)
            },
            {
                id:4,
                label:'Low Risk',
                badge: 1,
                content: (<Typography variant="body1" align="center" > 4 </Typography>)
            },

        ]
        const header = (
            <div>
                <Grid container spacing={grid_spacing} justify="flex-start">
                    <Grid lg={8} item>
                        <CustomizedNameCard
                            content={[data.name]}
                            action = {true}
                        />
                    </Grid>
                    <Grid lg={4} item>
                        <CustomizedNameCard
                            content={['Total Tender Value:','$950,890']}
                            action = {true}
                        />
                    </Grid>
                    <Grid lg={12} item>
                        <CustomizedCard
                            header={'Vender Risk Value:'}
                            content = {vender_risk_score}
                            cardStyle = {'veryShort'}
                        />
                    </Grid>
                    <Grid lg={12} item>
                        <CustomizedTab
                            data={tabdata}
                        />
                    </Grid>
                </Grid>
            </div>
        )
        const testEmails = ["yongyibian@kpmg.com", "elisa@kpmg.com", "yuri@kpmg.com", "jiajie@kpmg.com", "koonhan@kpmg.com"]
        const inputHeader = (
            <ChipInput
                hintText='Assignees Email'
                dataSource={testEmails}
                fullWidth
            />
        )
        const dialog = (<Dialog
            open={this.state.open}
            onClose={this.handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{"Action confirmaton"}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Proceed with your action?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={this.handleClose} color="primary">
                    Cancel
              </Button>
                <Button onClick={this.handleClose} color="primary" autoFocus>
                    Yes
              </Button>
            </DialogActions>
        </Dialog>
        )
        const hardCodedChips = (
            <span>
                <AlertChip
                    label="Conflict Interest"
                    color="mid"
                />
                <AlertChip
                    label="Duplicate Address"
                    color="mid"
                />

            </span>
        )
        const content_height = (this.state.height - 375) + "px";
        const content_style = {
            height: content_height,
        };
        const actionView = (
            <Card className={classes.card} style={content_style}>
                <CardActions className={classes.actions}>
                    <Button variant="outlined" size="small" color="secondary" onClick={this.handleViewToggle}>Discard</Button>
                </CardActions>
                <Divider />
                <CardHeader
                    avatar={
                        <Button variant="outlined" size="medium" color="primary">
                            <EmailIcon />
                        </Button>
                    }
                    title={inputHeader}
                    className={classes.header}
                />
                <Divider />
                <CardHeader
                    avatar={
                        <Avatar aria-label="Recipe" className={classes.avatar}>
                           SLA
                        </Avatar>
                    }
                    action={
                        null
                    }
                    title={header}
                    subheader="September 14, 2016"
                    className={classes.header}
                />
                <Divider />
                <CardContent className={classes.actionContent}>
                    <TextField
                        id="full-width"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        multiline
                        placeholder="Body"
                        helperText="Please input reasons or instructions before you dispatch this alert to another person in charge"
                        fullWidth
                        margin="normal"
                    />
                </CardContent>
            </Card>
        );
        const detailsView = (
            <Card className={classes.card}>

                <CardHeader

                    action={
                        null
                    }
                    title={header}
                    subheader={data.description}
                    className={classes.header}
                />
                <Divider/>
                <CardContent className={classes.content}>
                    <Typography variant="title">Master Information</Typography>
                    <HorizontalTable detail={data}/>
                </CardContent>                
                {/* <Divider/> */}
                <CardContent className={classes.content}>
                    
                </CardContent>
            </Card>
        );


        return (
            <div>
                {header}
                {dialog}
            </div>
        );
    }
}

RecipeReviewCard.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RecipeReviewCard);


// WEBPACK FOOTER //
// ./src/components/Entities/vendor/VendorListDetail.js